import Vue from 'vue'

Vue.filter('fhNumber', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  return new Intl.NumberFormat('de-DE').format(value)
})

Vue.filter('fhIntegerNumber', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  return new Intl.NumberFormat('de-DE', {maximumFractionDigits: 0}).format(value)
})

Vue.filter('fhDecimalNumber', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  return new Intl.NumberFormat('de-DE', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(value)
})

Vue.filter('fhDate',
  /** @param {string} value  */
  function (value) {
    if (!value) return value

    return value.split('T')[0].split('-').reverse().join('/')
  }
)

Vue.filter('fhSlug',
  /** @param {string} value  */
  // From https://medium.com/@mhagemann/the-ultimate-way-to-slugify-a-url-string-in-javascript-b8e4a0d849e1
  function (value) {
    if (!value) return value

    const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœøṕŕßśșțùúüûǘẃẍÿź·/_,:;'
    const b = 'aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuwxyz------'
    const p = new RegExp(a.split('').join('|'), 'g')
    return value.toString().toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/[^\w-]+/g, '') // Remove all non-word characters
      .replace(/--+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }
)

Vue.filter('fhDynamicVerboseDateTimeUtc',
  /** @param {string} value */
  function (value) {
    if (!value) return value

    let date = new Date(Date.parse(value))
    let dateNow = new Date()
    let dateYesterday = new Date(dateNow - 24*60*60*1000)

    let day = ''
    let month = ''
    let year = ', '

    // if today
    if (date.getFullYear() === dateNow.getFullYear() && date.getMonth() === dateNow.getMonth() && date.getDate() === dateNow.getDate()) {
      day = 'Hoy'
    }
    // else if yesterday
    else if (date.getFullYear() === dateYesterday.getFullYear() && date.getMonth() === dateYesterday.getMonth() && date.getDate() === dateYesterday.getDate()) {
      day = 'Ayer'
    }
    else {
      let weekdayList = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']

    // weekday and day of month
      day = weekdayList[date.getDay()] + ', ' + date.getDate()

      // month (this month empty)
      let monthList = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
      if (date.getFullYear() !== dateNow.getFullYear() || (date.getFullYear() === dateNow.getFullYear() && date.getMonth() !== dateNow.getMonth())) {
        month = ' de ' + monthList[date.getMonth()]
      }

      // year (this year empty)
      if (date.getFullYear() !== dateNow.getFullYear()) {
        year = ' del ' + date.getFullYear() + ', '
      }
    }

    // time
    let hour = (date.getHours() + '').padStart(2, '0')
    let minutes = (date.getMinutes() + '').padStart(2, '0')
    let time = hour + ':' + minutes

    return day + month + year + time
  }
)
